import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { generalClient } from '../../../../utils/apollo/api'
import { useLinkTreeActions } from './_actions/LinkTreeActions'
import { useLinkTrees } from '../_load/LinkTreeLoader'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'

const LinkTreesTable = () => {
  const { t } = useTranslation('listLinkTrees')
  const data = useModalData()
  const list = useLinkTrees()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={generalClient}
            entity="linkTrees"
            filterName="LinkTreeFilter"
            filters={{ placeTypes: data.placeType }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 4,
      bold: true
    },
    {
      label: t('createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },
    {
      label: t('enabled'),
      dataIndex: 'enabled',
      sortIndex: 'ENABLED',
      flex: 1,
      render: (_, record) => (
        <SwitchDisabled client={generalClient} entity="LinkTree" record={record} size={'small'} disabled={false} />
      )
    },
    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useLinkTreeActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={list} inPanel size="medium" />
}

export default LinkTreesTable
